import { fetchJson } from '@brandfolder/react';
import { Dispatch, SetStateAction } from 'react';

import { CreateLimitData } from '../customLimitsTypes';

const combinedLimitsPostUrl = (
  orgKey: string,
): string =>
  `api/v4/organizations/${orgKey}/combined_limits`;

export const postCombinedLimits = async (
  payload: Array<CreateLimitData>,
  orgKey: string,
  setLimitsSuccess: Dispatch<SetStateAction<boolean>>
): Promise<void> => {
  const bearerToken = BFG.BF_Token;

  try {
    await fetchJson({
      body: {
        data: payload,
      },
      // eslint-disable-next-line @typescript-eslint/naming-convention
      headers: { Authorization: 'Bearer ' + bearerToken },
      method: 'POST',
      url: combinedLimitsPostUrl(orgKey),
    }).then(() => setLimitsSuccess(true));
  } catch (err) {
    setLimitsSuccess(false);
  }
};
